import { IProductCatalog } from '../graphQL/commons'

export const calculateOutOfStock = ({
  outOfStock,
  extraPackages,
}: IProductCatalog): boolean =>
  outOfStock && !extraPackages?.some(({ stock }) => stock)
